import { ErrorName } from 'src/constants';

export const getPayloadFromErrorResponse = (error: any) => {
  if (error?.response?.data) {
    return error.response.data;
  }

  // Check for explicit HTTP 504 response (gateway sent headers before dropping connection)
  if (error?.response?.status === 504) {
    return {
      name: ErrorName.GatewayTimeout,
      message:
        'Unable to complete the action. Server is taking too long to respond. Please try again or contact clientservices@myipo.com for assistance.',
    };
  }

  if (error.code === 'ERR_NETWORK') {
    // navigator.onLine false → device has no network; true → gateway dropped the TCP connection
    if (navigator.onLine) {
      return {
        name: ErrorName.GatewayTimeout,
        message:
          'Unable to complete the action. Server is taking too long to respond. Please try again or contact clientservices@myipo.com for assistance.',
      };
    }

    return {
      name: ErrorName.Network,
      message:
        'Unable to complete the action. Network error occurred. Please make sure your Internet connection is stable and try again.',
    };
  }

  return {
    error: error.name ?? ErrorName.Unknown,
    name: error.name ?? ErrorName.Unknown,
    message: error.message,
  };
};

export const isUnauthorizedResponseError = (error: any) => {
  if (error?.response?.status) {
    return error?.response?.status === 401;
  }

  return error?.statusCode === 401;
};
